import React from 'react';
import PropTypes from 'prop-types';

import styles, { mainCls } from './styles';
import createStyle from '../../Utils/createStyle';
import makeClassName from '../../Utils/makeClassName';

const useStyles = createStyle(styles);

export default function Spinner({
  className,
  color,
  size,
  weight,
  inline,
  block,
  noOpacity = false,
  valignCenter = false,
  ...props
}) {
  const classes = useStyles();
  const clsWrp = makeClassName([
    className,
    `tp-a--c`,
    inline ? classes[`${mainCls}__wrp--inl`] : '',
    valignCenter ? classes[`${mainCls}__wrp--vac`] : '',
  ]);

  const noOpacityClass = noOpacity ? classes[`${mainCls}__no-opacity`] : '';
  const clsSpin = makeClassName([
    `${classes[mainCls]} c-br--${color} b--${weight} size--${size} b-r--100`,
    block && 'is-block',
    noOpacityClass,
  ]);

  return (
    <div className={clsWrp} { ...props }>
      <div className={clsSpin} />
    </div>
  );
};

Spinner.propTypes = {
  /**
   * Action to perform, could be an URL (as string) or any callback (as a function)
   */
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),

  /**
   * Spinner color (use Color Tokens)
   */
  color: PropTypes.string,

  /**
   * Spinner size (use Size Tokens)
   */
  size: PropTypes.string,

  /**
   * Spinner border weight (Use Border weight tokens)
   */
  weight: PropTypes.string,

  /**
   * Make the spinner inline
   */
  inline: PropTypes.bool,

  /**
   * Make the spinner behave as a block
   */
  block: PropTypes.bool,

  /**
   * Vertical align spinner
   */
  valignCenter: PropTypes.bool,
};

Spinner.defaultProps = {
  className: '',
  color: 'primary',
  size: 'm',
  weight: 'm',
  inline: false,
  block: false,
  valignCenter: false,
};
